export enum AppModuleSection {
  MASTER_DATA_INPUT_SECTION_ID = 1,
  LINE_ITEM_SECTION_ID = 2,
  ITEM_COST_DISTRIBUTION_SECTION_ID = 3,
  EXPENSE_COST_DISTRIBUTION_SECTION_ID = 4,
  ADDITIONAL_FIELD_SECTION_ID = 3,
  VENDOR_BASIC_INFO_SECTION = 5,
  POSTAL_ADDRESS_SECTION = 6,
  REMIT_ADDRESS_SECTION = 7,
  W9_INFO_SECTION = 8,
  PURCHASING_ACCOUNT_INFO = 9,
  VENDOR_PAYMENT_INFO_SECTION = 10,
}
